import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../../common/DisplayData/DisplayData";
import ActionBar from "../../../common/ActionBar/ActionBar";
import BlockIcon from "../../../common/Icons/BlockIcon";
import ActivateIcon from "../../../common/Icons/ActivateIcon";
import Button from "../../../common/VFX-UI/Button/Button";

//App
import useComponentGeneralStyles from "../../../styles";
import { EMPTY_GUID } from "../../../../utility/constants";
import { LookupGroupViewProps } from "../../../../types/lookupGroup";
import { LookupGroupContext } from "./LookupGroupContainer";

const LookupGroupView = (props: LookupGroupViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const lookupGroupContext = useContext(LookupGroupContext);
  const generalStyles = useComponentGeneralStyles();

  const lookupGroup = lookupGroupContext?.data;

  const lookupType = lookupGroupContext?.lookupTypes?.find(
    (lookupType) =>
      (lookupType as Record<string, string>)["value"] === lookupGroup?.typeId
  );

  return (
    <FormBackGround>
      <FormHeader
        title="View Lookup Group"
        onClose={onClose}
        editActionHandler={editAction}
      />
      <>
        <DisplayData text="Name" importedData={lookupGroup?.name}></DisplayData>
        <DisplayData
          text="Description"
          importedData={lookupGroup?.description}
        ></DisplayData>
        <DisplayData
          text="Lookup Type"
          importedData={(lookupType as Record<string, string>)["label"]}
        ></DisplayData>
        {/* {lookupGroup?.id &&
          lookupGroup?.id !== EMPTY_GUID &&
          lookupGroup?.isActive && (
            <Container>
              <Button
                style={generalStyles.deleteButton}
                onClick={toggleDeactivateHandler}
              >
                <BlockIcon />
              </Button>
            </Container>
          )}
        {lookupGroup?.id &&
          lookupGroup?.id !== EMPTY_GUID &&
          !lookupGroup?.isActive && (
            <Container>
              <Button
                style={generalStyles.activateButton}
                onClick={toggleActivateHandler}
              >
                <ActivateIcon />
              </Button>
            </Container>
          )} */}
      </>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default LookupGroupView;
